
// @mui
import Container from '@mui/material/Container';
// routes
import { useLocation } from 'react-router';
import { paths } from 'src/routes/paths';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { useRouter } from 'src/routes/hooks';
import TourPlanForm from '../tour-plan-form';

// ----------------------------------------------------------------------

export default function ViewTourPlan() {
    const settings = useSettingsContext();

    const { state } = useLocation();

    const router = useRouter();

    if (state == null) {
        router.push(paths.dashboard.affordable.tourPlan)
    }

    return (
        <Container maxWidth={settings.themeStretch ? false : 'lg'}>
            <CustomBreadcrumbs
                heading="View Tour Plan"
                links={[
                    {
                        name: 'Dashboard',
                        href: paths.dashboard.driverReview.root,
                    },
                    {
                        name: 'Tour Plan',
                        href: paths.dashboard.affordable.tourPlan,
                    },
                    { name: 'View Tour Plan' },
                ]}
                sx={{
                    mb: { xs: 3, md: 5 },
                }}
            />
            <TourPlanForm tourPlan={state.tourPlan} isView />
        </Container>
    );
}

